export default "__VITE_ASSET__DikisUCE__"